import { useState } from 'react';
import { useRightPanel } from '@/components/layout/workspace/rightPanelContext';
import { Badge, Button, Checkbox, FileChip, FileDropzone, FilePasteArea, Textarea } from '@/components/ui';
import { HOME } from './model';
import { useOperations } from './operationsContext';

export function AttachmentDemo() {
  const { files, addFiles, retry } = useOperations();
  const panel = useRightPanel();
  const [fail, setFail] = useState(false);
  const [text, setText] = useState('');
  const [sent, setSent] = useState(false);
  const attach = (list: File[], area: 'card' | 'comment') => {
    addFiles(list, area, fail);
    setFail(false);
  };
  return (
    <div data-demo="files" className="flex flex-col gap-6">
      <div className="rounded-lg border border-line bg-card p-5">
        <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
          <div>
            <h3 className="type-heading">Вложения к записи</h3>
            <p className="mt-1 text-sm text-fg-muted">
              Картинки и PDF открываются в правой панели своего окна.
            </p>
          </div>
          <Badge>№ 042</Badge>
        </div>
        <FileDropzone onFiles={(list) => attach(list, 'card')} />
        <p className="mt-3 text-xs text-fg-muted">
          До 25 МБ на файл. В образце файлы остаются в браузере до обновления страницы.
        </p>
        <div className="mt-4 grid gap-3 xl:grid-cols-2">
          {files
            .filter((f) => f.area === 'card')
            .map((file) => (
              <FileChip
                key={file.id}
                file={file}
                onRetry={() => retry(file.id)}
                onOpen={() =>
                  panel.open(
                    {
                      id: 'file:' + file.id,
                      title: file.name,
                      path: HOME + '/file/' + file.id,
                      eyebrow: 'Вложение',
                    },
                    document.activeElement as HTMLElement,
                  )
                }
              />
            ))}
        </div>
      </div>
      <div className="rounded-lg border border-line bg-card p-5">
        <h3 className="mb-4 type-heading">Вложение в комментарий</h3>
        <FilePasteArea label="Вставка скриншота в комментарий" onFiles={(list) => attach(list, 'comment')}>
          <Textarea
            aria-label="Текст комментария"
            placeholder="Напиши комментарий или вставь скриншот…"
            value={text}
            onChange={(e) => {
              setText(e.target.value);
              setSent(false);
            }}
            rows={3}
          />
          <div className="mt-3 flex flex-col gap-3">
            {files
              .filter((f) => f.area === 'comment')
              .map((file) => (
                <FileChip
                  key={file.id}
                  file={file}
                  onRetry={() => retry(file.id)}
                  onOpen={() =>
                    panel.open(
                      { id: 'file:' + file.id, title: file.name, path: HOME + '/file/' + file.id },
                      document.activeElement as HTMLElement,
                    )
                  }
                />
              ))}
          </div>
        </FilePasteArea>
        <div className="mt-4 flex flex-wrap items-center justify-between gap-4">
          <p role="status" className="text-xs text-fg-muted">
            {sent ? 'Комментарий добавлен в образец' : 'Обычный текст из буфера вставляется без изменений.'}
          </p>
          <Button
            size="sm"
            variant="secondary"
            disabled={!text.trim() || files.some((f) => f.area === 'comment' && f.state !== 'ready')}
            onClick={() => setSent(true)}
          >
            Добавить комментарий
          </Button>
        </div>
      </div>
      <Checkbox
        label="Сбой следующего добавления — проверить повтор"
        checked={fail}
        onCheckedChange={(v) => setFail(v === true)}
      />
    </div>
  );
}
